<template>
    <div>
        <template v-if="! loading">
            <b-row class="mb-2">
                <b-col class="col-12">
                    <b-card class="mb-0">
                        <b-card-title title-tag="h5" title="Settings"></b-card-title>
                        <b-card-body class="px-0">
                            <table class="table table-bordered table-hover">
                                <thead>
                                    <tr>
                                        <th class="col-4">Setting</th>
                                        <th class="col-2">Value</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="col-4">Booking Open</td>
                                        <td class="col-2">
                                            <b-form-checkbox size="xl" v-model="bookingStatus" @change="toggleBooking" switch></b-form-checkbox>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="col-4">Member Number</td>
                                        <td class="col-2">{{ memberNumber }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </b-card-body>
                    </b-card>
                </b-col>
            </b-row>
        </template>
    </div>
</template>

<script>
export default {
    props: {
        settingsRaw: {
            default: false,
        },
    },
    data() {
        return {
            loading: false,
            bookingStatus: false,
            memberNumber: 0,
        }
    },
    methods: {
        toggleBooking() {
            axios.put(this.$routes.route('booking.toggleBookingMode'), {})
                .then(response => {
                    console.log(response);
                })
                .catch(error => {
                    console.log(error);
                });
        },
        init() {
            console.info('Settings init', this.settingsRaw);
            if (this.settingsRaw) {
                // this.settingsRaw is a collection of settings iterate over them to find the settings we need
                this.settingsRaw.forEach((setting) => {
                    if (setting.key === 'booking_open') {
                        // Convert the value to boolean
                        this.bookingStatus = setting.value === '1';
                    }
                    if (setting.key === 'member_number') {
                        this.memberNumber = setting.value;
                    }
                });

                this.loading = false;
            }
        },
    },
    mounted() {
        this.loading = true;
        setTimeout(() => {
            this.init();
        }, 10);
        // this.init();
    }
}
</script>